import { API } from "aws-amplify";
import { AxiosError } from "axios";
import { useQuery, useQueryClient } from "react-query";
import { ICohort } from "../../../../routes/registries/models/Cohort";
import { APIEndpoints, QueryKeys } from "../../config";

const makeApiRequest = (cohortId: string): Promise<ICohort> => {
  const qParams = {};

  return API.get(APIEndpoints.private, `/api/v1/cohorts/${cohortId}`, qParams);
};

export default function useReadCohort(cohortId) {
  const queryClient = useQueryClient();

  return useQuery<ICohort, AxiosError>(
    QueryKeys.cohortsDetail(cohortId),
    () => makeApiRequest(cohortId),
    {
      initialData: () => {
        return queryClient
          .getQueryData<ICohort[]>(QueryKeys.cohorts())
          ?.find((d) => d.id === cohortId);
      },
      staleTime: 0,
      retry: 1,
      enabled: !!cohortId,
    }
  );
}
